import { mergeSxProps, Text } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { Container, Stack, type SxProps, ThemeProvider } from "@mui/material";

import { PageWrapper } from "../redesign/components/PageWrapper";

interface ErrorPageTemplateProps {
  /**
   * The logo to display at the top of the error page
   */
  illustration: React.ReactNode;
  /**
   * The main heading text for the error
   */
  title: string;
  /**
   * The description text explaining the error
   */
  description: string;
  /**
   * The action buttons to display at the bottom
   */
  actions: React.ReactNode;

  sx?: SxProps;
}

export function ErrorPageTemplate(props: ErrorPageTemplateProps) {
  const { illustration, title, description, actions, sx } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper
        // merge sx props
        sx={mergeSxProps(
          {
            background: (theme) => theme.palette.intent?.neutral.gradient,
            ...getSafeAreaPaddings({ bottom: true, fallbackBottom: "24px" }),
            paddingX: 2,
          },
          sx
        )}
      >
        <Container
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Stack
            spacing={10}
            alignItems="center"
            textAlign="center"
            sx={{
              flex: 1,
              justifyContent: "center",
              mb: 3,
            }}
          >
            {illustration}

            <Stack spacing={4}>
              <Text semibold variant="h3">
                {title}
              </Text>
              <Text variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
                {description}
              </Text>
            </Stack>
          </Stack>
          {actions}
        </Container>
      </PageWrapper>
    </ThemeProvider>
  );
}
